export const activity = {
  activityWebEmptyStateTitle: 'Нет уведомлений',
  activityWebEmptyStateText: 'В будущем здесь будут твои уведомления',
  activitySeeAll: 'Смотреть все',
  in: 'в'
}
